<template>
    <div class="pages_content table">
        <el-radio-group v-model="tabType" fill="#128949" :border="true">
            <el-radio-button label="site">站点模板</el-radio-button>
            <el-radio-button label="default">模板库</el-radio-button>
        </el-radio-group>
        <!-- 站点模板 -->
        <el-row v-if="tabType === 'site'">
            <!-- 站点列表 -->
            <el-col :span="4">
                <div v-loading="treeLoading" class="tree">
                    <el-tree ref="tree" :data="treeData" default-expand-all :expand-on-click-node="false">
                        <span slot-scope="{ node,data }" class="custom-tree-node tree-line">
                            <span v-if="data.children">
                                <i :class="data.icon"></i>
                                <span>{{ node.label }}</span>
                            </span>
                            <el-radio-group v-else v-model="activetree" @change="activetree = data.value, getSiteList()">
                                <el-radio :label="data.value">
                                <span>{{ node.label }}</span>
                                </el-radio>
                            </el-radio-group>
                        </span>
                    </el-tree>
                </div>  
            </el-col>
            <!-- 过磅小票栏 -->
            <el-col :span="3">
                <TemplateTypeList :curType="curTemplate" @changeType="getTempType"></TemplateTypeList>
            </el-col>
            <!-- 小票模板列表 -->
            <el-col :span="17">
                <el-button type="success" style="margin-bottom: 10px;background: #018F3A;" @click="useToForm">应用于其他站点</el-button>
                <el-button type="success" style="margin-bottom: 10px;background: #018F3A;" @click="handleSiteTicketTemplate">调整站点模板</el-button>
                <el-table
                    :data="siteList"
                    border
                    :max-height="screenHeight - 300"
                    style="width: 100%">
                    <el-table-column prop="templateName" label="模板名称"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <!-- <el-table-column prop="priority" label="优先级"></el-table-column> -->
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button style="color: #018F3A;" type="text" size="small" @click="delStationTem(scope.row)">删除模板</el-button>
                            <!-- <el-button style="color: #018F3A;" type="text" size="small" @click="handlePriorityClick(scope.row)">优先级</el-button> -->
                            <el-button style="color: #018F3A;" type="text" size="small" @click="handleConditionClick(scope.row)">使用条件</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- 模板库 -->
        <el-row v-if="tabType === 'default'">
            <el-col :span="3">
                <TemplateTypeList :curType="curDefTemplate" @changeType="getDefTempType"></TemplateTypeList>
            </el-col>
              <!-- 小票模板列表 -->
            <el-col :span="21">
                <el-button type="success" style="margin-bottom: 10px;background: #018F3A;" @click="handleAddTemplate">添加</el-button>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">模板名称</span>
                  <el-input v-model="templateName" style="width: 150px" placeholder="请输入" clearable />
                  <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="getDefTempList()">查 询</el-button>
                </span>
                <el-table
                    :data="defaultList"
                    border
                    :max-height="screenHeight - 300"
                    style="width: 100%">
                    <el-table-column prop="templateName" label="模板名称"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button style="color: #018F3A;" type="text" size="small" @click="handleStationEdit(scope.row)">修改</el-button>
                            <el-button style="color: #D9001B;" type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
                            <el-button style="color: #018F3A;" type="text" size="small" @click="handleCopy(scope.row)">复制模板</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <!-- 应用于其他站点 -->
        <el-dialog
        title="应用于其他站点"
        :visible.sync="useToVisible"
        width="400px">
            应用业务：{{pointName}},{{curTemplate.label}}
            <div style="height: 70vh; overflow: auto; margin-top: 15px;">
                <el-tree ref="useToTree" node-key="value" :data="useToTreeData" default-expand-all show-checkbox :expand-on-click-node="false">
            </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="useToVisible = false">取 消</el-button>
                <el-button class="bottom_all"  @click="submitUseTo">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 调整站点模板 -->
         <el-dialog
        title="调整站点模板"
        :visible.sync="handleTemplateDialog"
        append-to-body
        width="600px"
        >
         <el-row>
           <!--  <el-col :span="7">
                <TemplateTypeList :curType="curDefTemplate" @changeType="getDefTempType"></TemplateTypeList>
            </el-col> -->
              <!-- 小票模板列表 -->  
            <el-col :span="24">
                <el-table
                    :data="setStationList"
                    border
                    :max-height="screenHeight - 300"
                  style="width: 100%;margin-left:10px" >
                    <el-table-column prop="templateName" label="模板名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <!-- 待修改 -->
                            <!-- 添加了新模板后，站点模板也随之更新，需要后端协助 -->
                            <el-button style="color: #018F3A;" type="text" size="small" @click="handleEdit(scope.row)">添加模板</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        </el-dialog>
        <!-- 优先级 -->
       <!--  <el-dialog
        title="优先级"
        :visible.sync="priorityVisible"
        width="400px">
            <el-form ref="form" label-width="80px">
                <el-form-item label="优先级">
                    <el-input v-model="priority" placeholder="只能输入正整数，不能和其他数据重复"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="priorityVisible = false">取 消</el-button>
                <el-button class="bottom_all"  @click="submitPriority">确 定</el-button>
            </span>
        </el-dialog> -->


        <!-- 使用条件 -->
        <el-dialog
        title="使用条件"
        :visible.sync="conditionVisible"
        width="960px">
            应用业务：{{pointName}},{{curTemplate.label}}，模板：{{curRow.templateName}}
            <div style="margin: 10px 0;">
                <el-button class="bottom_all"  size="small" @click="HandleAddCondition">添加条件(或)</el-button>
            </div>
            <el-table
            :key="tableKey"
                :data="condList"
                border
                :max-height="screenHeight - 300"
                style="width: 100%">
                    <el-table-column type="index" width="50"></el-table-column>
                    <el-table-column label="条件业务" width="180">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.conditionName" @change="changeCondition(scope.row)">
                                <el-option v-for="(item, index) in curTemplate.conditionList" :key="index" :value="item.key" :label="item.label"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="条件数据" >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.conditionData" :placeholder="scope.row.remark"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button style="color: #D9001B;" type="text" size="small" @click="handleDelCondClick(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
            </el-table>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="conditionVisible = false">取 消</el-button>
                <el-button class="bottom_all"  @click="submitCondition">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import TemplateTypeList from "./components/templateTypeList.vue"
// API
import { getUserAutList } from "@/api/common.js";
import { getTicketTemplateList, delTicketTemplate, delSmallTicketTemplate,/* getSiteTicketTemplateList ,*/ querySmallTicketTemplate,/* saveOrUpdatePriority, */
    getConditionList, saveCondition,
    useToSite ,insertStationSmallTicketTemplate} from "@/api/basicConfig/ticketTemplate"
export default {
    components: { TemplateTypeList },
    data() {
        return {
            tabType: 'site',
            treeData: [],
            activetree: "",
            treeLoading: false,
            pointName: '',
            curTemplate: {
                key: 'rawSupply',
                label: '原物料供货',
                conditionList: []
            },
            siteList: [
                {
                    id: '',
                    name: '原物料供货Roger',
                    type: '原物料供货',
                    remark: 'test',
                   /*  priority: 1 */
                }
            ],
            curRow: false,
            // 应用于
            useToVisible: false,
            //调整站点模板弹窗
            handleTemplateDialog:false,
            useToTreeData: [],
            // 优先级
            /* priority: 0, */
           /*  priorityVisible: false, */
            // 使用条件
            conditionVisible: false,
            condList: [],
            condBussinessList: [],
            condDataList: [],
            // 默认模板部分
            defaultList: [],
            curDefTemplate: {
                parentKey: 'weigthTicket',
                key: 'rawSupply',
                label: '原物料供货'
            },
            screenHeight:0,
            tableKey:false,
            templateName:"",
        }
    },
    async created() {
        /* 获取站点模板树 */
        this.treeData = await getUserAutList()
        /* 设置默认模板 */
        this.activetree = this.treeData[0].children[0].value;
        // this.fromDate.pointName = this.treeData[0].children[0].label;
        this.pointName = this.treeData[0].children[0].label;
        this.treeLoading = false;
        this.screenHeight = document.documentElement.clientHeight;
        console.log(this.screenHeight)
        // 获取基础数据
        this.getDefTempList()
        // 获取站点数据
        this.getSiteList()
    },
    computed:{
     setStationList(){
         //获取站点模板和模板库的差集
         return this.defaultList.filter(def=>!this.siteList.find(sit=>def.id==sit.templateId))
        } 
    },
    methods: {
        /**
         * 获取默认数据模板
         */
        getDefTempList() {
            let params = {
                page: 1,
                pageSize: 1000,
                firstLevelMenuKey: this.curDefTemplate.parentKey,
                secondLevelMenuKey: this.curDefTemplate.key,
                templateName:this.templateName,
            }
            /* 获取模板列表库的内容 */
            getTicketTemplateList(params).then(res => {
                console.log(res);
                this.defaultList = res.data.data
            })
        },
        getSiteList() {
            let params = {
                page: 1,
                pageSize: 1000,
                stationId: this.activetree,
                firstLevelMenuKey: this.curTemplate.parentKey,
                secondLevelMenuKey: this.curTemplate.key,
            }
            /* 获取站点模板的内容 */
            querySmallTicketTemplate(params).then(res => {
                this.siteList =res.data.data
            })
        },

        /* 点击过磅小票栏 */
        getTempType(data) {
            //过磅小票树节点
            this.curTemplate = data
            console.log(data)
            this.getSiteList()

            this.curDefTemplate = data
            this.getDefTempList()
            // 获取模板数据
        },
        /* 应用于其他站点 */
        useToForm() {
            this.useToTreeData = [...this.treeData]
            this.useToVisible = true
        },
        /* 调整站点模板 */
        handleSiteTicketTemplate(){
            this.handleTemplateDialog=true
        },

        // 提交应用于
        submitUseTo() {
            let ids = this.$refs.useToTree.getCheckedKeys()
            if (ids.length === 0) {
                this.$message.warning('请选择应用站点')
                return
            }
            let params = {
                firstLevelMenuKey: this.curRow.firstLevelMenuKey,
                secondLevelMenuKey: this.curRow.secondLevelMenuKey,
                stationId: this.curRow.stationId,
                applicationStationIdList: ids
            }
            useToSite(params).then((res) => {
                if (res.code === 1001) {
                    this.$message.success('操作成功')
                    this.useToVisible = false
                }
            })
        },
       /*  handlePriorityClick(row) {
            this.curRow = row
            this.priority = row.priority || ''
            this.priorityVisible = true
        }, */
 /*        submitPriority() {
            let temp = this.siteList.filter(item => {
                return item.priority === this.priority && item.templateId != this.curRow.templateId
            })
            if (temp.length) {
                this.$message.warning('当前业务的优先级能相同')
                return
            }
            saveOrUpdatePriority({
                firstLevelMenuKey: this.curRow.firstLevelMenuKey,
                priority: this.priority,
                secondLevelMenuKey: this.curRow.secondLevelMenuKey,
                stationId: this.curRow.stationId,
                station: this.curRow.station,
                templateId: this.curRow.templateId,
            }).then(() => {
                this.$message.success('操作成功')
                this.getSiteList()
                this.priorityVisible = false
            })
        }, */
        
        /* 使用条件 */
        handleConditionClick(row) {
            this.curRow = row
            getConditionList({id: row.stationTemplateId}).then(res => {
                let list = res.data.conditionList || []
                list.map(item => {
                    item.remark = ''
                })
                this.condList = list
                this.conditionVisible = true
            })
        },
        //删除站点模板
        delStationTem(row){
             this.$confirm(`是否删除当前站点小票模板`, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  cancelButtonClass: "bottom_all_two",
                  confirmButtonClass: "bottom_all",
                  type: "warning",
                }).then(()=>{
                     delSmallTicketTemplate({stationTemplateId:row.stationTemplateId}).then((res)=>{
                            if(res.code==1001){
                                            this.getSiteList()
                             }
                     })
                })
        },
        changeCondition(row) {
            let condItem = this.curTemplate.conditionList.filter(item => {
                return item.key === row.conditionName
            })
            if (condItem.length) {
                row.remark = condItem[0].remark
            } else {
                row.remark = ''
            }
        },
        HandleAddCondition() {
            this.condList.push({
                conditionName: '',
                conditionData: '',
                remark: '请选择条件业务'
            })
        },
        handleDelCondClick(index) {
            this.$confirm('此操作将永久删除该模板?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'bottom_all_two',
                confirmButtonClass: 'bottom_all',
                type: 'warning'
            })
            .then(() => {
                this.condList.splice(index, 1)
            })
            .catch(() => { });
        },
        submitCondition() {
            let row = this.curRow
            let params = {
                firstLevelMenuKey: row.firstLevelMenuKey,
                secondLevelMenuKey: row.secondLevelMenuKey,
                stationId: row.stationId,
                station: row.station,
                templateId: row.templateId,
                conditionList: this.condList
            }
            saveCondition(params).then(() => {
                this.$message.success('使用条件保存成功')
                this.getSiteList()
                this.conditionVisible = false
            })
        },
        // 添加模板库
        handleAddTemplate() {
            this.$router.push({
                path: "/lvshe/icps/editTicketTemplate",
                query: this.curDefTemplate
            });
        },
        //修改模板库的模板
        handleStationEdit(row){
            let form = {
                id: row.id,
                firstLevelMenuKey: row.firstLevelMenuKey,
                secondLevelMenuKey: row.secondLevelMenuKey,
                templateName: row.templateName,
                remark: row.remark,
                content: row.content,
              }
            this.$router.push({
                path: "/lvshe/icps/editTicketTemplate",
                query: {
                    form: encodeURIComponent(JSON.stringify(form))
                }
            });
        },
        getDefTempType(data) {
            console.log(data);
            //模板库树节点
            this.curDefTemplate = data
            this.templateName = '';
            this.getDefTempList()
        },

        //添加站点模板
        handleEdit(row) {
            //这样才能获取this.siteList[0]
            this.timer= setTimeout(() => {
                let form = {
                firstLevelMenuKey: row.firstLevelMenuKey,
                secondLevelMenuKey: row.secondLevelMenuKey,
                templateId:row.id,
                //此处有bug是根据站点模板带出的站点信息来获取站点id的，若站点内没有模板则不能添加模板
                 /* stationId:this.siteList[0].stationId, */
                /* station:this.siteList[0].station, */
                //应该使用activetree
                stationId:this.activetree,
                /* station:"原物料供货",
                stationId:"133778035949309952", */
            }
            insertStationSmallTicketTemplate(form).then((res)=>{
                    if(res.code===1001){
                            //添加成功后需要重新获取列表
                           this.getSiteList()
                    }
            })
            }, 200);
            
        },
        handleDel(row) {
            this.$confirm('此操作将永久删除该模板?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'bottom_all_two',
                confirmButtonClass: 'bottom_all',
                type: 'warning'
            })
            .then(() => {
                let json = {
                    id: row.id,
                    status: 0
                }
                delTicketTemplate(json).then((res) => {
                    if (res.code == 1001) {
                        this.getDefTempList();
                    }
                })
                })
            .catch(() => { });
        },
        handleCopy(row) {
            let params = JSON.parse(JSON.stringify(row))
            params.id = undefined
            this.handleStationEdit(params)
        },
    }
}
</script>

<style lang="scss" scoped>
    .pages_content {
        padding: 10px;
    }

    .tree {
        padding: 0;
        padding-top: 15px;
        height: 80vh;
        width: 100%;
    }

    .el-radio-button__inner {
        width: 100px;
    }
</style>